module.exports = __webpack_public_path__ + "img/detail.cf223bfd.svg";